<template>
  <div id="artwork">
    <div class="bg-gray">
      <ol class="breadcrumb" v-if="$store.state.user">
        <li><a href="#/dashboard">Dashboard</a></li>

        <li><a href="#/myartworks">My Artworks</a></li>
        <li class="active">{{ artwork.name }}</li>
      </ol>
    </div>
    <div class="content login middle" v-loading="loading">
      <div class="cell">
        <div class="container">
          <div class="row" v-if="showReadyMessage">
            <div
              class="col-xs-5 mt5p"
              :style="{
                'padding-left': artwork.format == 'single' ? '110px' : '15px',
              }"
            >
              <p class="font16">The artwork is ready!</p>
              <p>You can now add it to your project or edit</p>
            </div>
          </div>
          <div class="row" v-if="isArtworkObsolete()">
            <div
              class="col-xs-5 mt5p"
              :style="{
                'padding-left': artwork.format == 'single' ? '110px' : '15px',
              }"
            >
              <artwork-obsolete-message />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-5 text-center mt5p">
              <img
                :style="{
                  width: (artwork.format == 'single' || $store.getters.isVertical)  ? '300px' : '600px',
                }"
                :src="checkImg(artwork.img)"
                alt=""
              />
            </div>
            <div class="col-xs-5 col-xs-offset-2 text-right">
              <h3 class="now">{{ artwork.name }}</h3>
              <div class="mt30 lh25">
                <p>Protocol: {{ artwork.protocol }}</p>
                <p>UID: {{ routeParamArtworkId }}</p>
              </div>

              <div class="mt30">
                <div class="action-menu">
                  <a @click="addToProject()" v-if="$store.state.user && !isArtworkObsolete()">
                    <span class="orange click inlineb font18"
                      >Add to a project</span
                    >
                  </a>
                  <a @click="design()" v-if="$store.state.user && !isArtworkObsolete()" class="black">
                    <span class="orange click inlineb font18"
                      >Edit Artwork</span
                    >
                  </a>

                  <a
                    v-if="!$store.state.user"
                    v-clipboard:copy="copyLink"
                    v-clipboard:success="onCopy"
                    ><span class="orange click inlineb font18">Copy Link</span>
                  </a>
                </div>

                <div class="row font12">
                  <div
                    class="col-xs-4 text-left"
                    v-if="
                      $store.state.user && $store.getters.canDownloadFile('PDF')
                    "
                  >
                    <router-link
                      class="black"
                      :to="'/pdfPreview/' + routeParam + '?c=' + $store.state.downloaderBrodcastId"
                      target="_blank"
                    >
                      <span class="button-icon icon-pdf_icon iconfont3"></span
                      ><br />
                      <span class="black mt10 inlineb">
                        Print artwork reference sheet (.PDF)
                      </span>
                    </router-link>
                  </div>
                  <div
                    class="col-xs-4 text-center"
                    v-if="
                      $store.state.user &&
                      $store.getters.canDownloadFile('CSV')
                    "
                  >
                    <a
                      @click="downloadCsv()"
                      class="black"
                    >
                      <span class="button-icon icon-csv_icon iconfont3"></span
                      ><br />
                      <span class="mt10 inlineb"
                        >Generate master product labels (.CSV)</span
                      >
                    </a>
                  </div>
                  <div
                    class="col-xs-4"
                    v-if="
                      $store.state.user &&
                      $store.getters.canDownloadFile('DXF')
                    "
                  >
                    <a @click="startDownloadDXF()" class="black">
                      <span class="button-icon icon-dxf_icon iconfont3"></span
                      ><br />
                      <span class="mt10 inlineb"
                        >Generate engraving file (.DXF)</span
                      >
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="nav-footer white font16">
      <span class="white click inlineb w10" @click="new_artwork()">
        MAKE A NEW ARTWORK
      </span>
      <span class="white click inlineb w15" @click="go_back_to_dashboard()">
        GO BACK TO DASHBOARD
      </span>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import isArtworkObsolete from "../mixins/isArtworkObsoleteMixin"
import ArtworkObsoleteMessage from '@/components/sections/ArtworkObsoleteMessage'
import artworkToProductMixin from "../mixins/artworkToProductMixin";
import checkSpecialChars from "../mixins/checkSpecialChars";

export default {
  name: "artwork",
  data() {
    return {
      routeParam: "",
      product: {},
      artwork: {},
      loading: true,
      dialogTableVisible: false,
      showReadyMessage: false,
      DownloaderBroadCast : new BroadcastChannel(this.$store.getters.downloaderBroadcastChannel())
    };
  },
  components: {
    ArtworkObsoleteMessage
  },
  mixins: [isArtworkObsolete, artworkToProductMixin, checkSpecialChars],
  computed: {
    copyLink() {
      return window.location.href;
    },
  },
  methods: {
    new_artwork() {
      this.$router.push({ path: "/collection" });
    },
    go_back_to_dashboard() {
      this.$router.push({ path: "/dashboard" });
    },
    checkImg(img) {
      if (typeof img == "undefined") return;
      if (img.includes("data:image")) {
        return img;
      } else {
        return (
          this.$store.state.serverURL + "/artwork/" + img + "?" + Date.now()
        );
      }
    },
    onCopy: function (e) {
      alert("You just copied: " + e.text);
    },
    design: function () {
      this.$router.push({ path: "/collection/engraving/" + this.routeParam });
    },
    addToProject: function () {
      this.$router.push({ path: "/addtoproject/" + this.routeParam });
    },
    downloadDXF() {
      this.DownloaderBroadCast.postMessage({ type: "initiateDownload", id: `dxf_${this.artwork._id}`, fileType: "dxf", fileName: "", data: this.artwork });
    },
    startDownloadDXF: function () {
      if (this.containsSpecialChars(this.artwork)) {
        this.$msgbox({
        title: "ATTENTION",
        message: "A non supported char has been detected – this artwork need to be manually approved and/or modified by our Artwork Team",
        showCancelButton: true,
        confirmButtonText: "Proceed wih download",
        cancelButtonText: "Cancel",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.downloadDXF();
          } 
          done();
        },
      });
      } else {
        this.downloadDXF();
      }
     
    },
    async downloadCsv() {
      this.DownloaderBroadCast.postMessage({ type: "initiateDownload", id: `csv_${this.artwork._id}`, fileType: "csv", fileName: "BN_" + this.artwork.name + "_Artwork.csv", data: this.artwork });
    },
  },
  async mounted() {
    var response;
    if (this.isRouteParamProduct) {
      response = await axios.get("product/single/" + this.routeParamProductId);
      this.product = response.data;
      this.artwork = this.product.artwork;
      this.routeParam = "p" + this.routeParamProductId;
    } else {
      response = await axios.get(
        "open/artwork/single/" + this.routeParamArtworkId,
        {
          withCredentials: false,
        }
      );
      if (response.data != null) {
          this.artwork = response.data;
          this.routeParam = this.routeParamArtworkId;
      } else {
        this.$router.push({ path: "/login" });
      }
    }
    this.$store.state.artwork = this.artwork;
    this.loading = false;
  },
  created: function () {
    this.$parent.footerB();
    this.$parent.footerW();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$data.showReadyMessage = from.name == "collection-complete";
    });
  },
};
</script>
<style lang="css" scoped>
.nav-footer {
  border-top: 1px solid #ccc;
}
</style>
